module.exports = __webpack_public_path__ + "img/ICRT_cancer_awarness_dark_large.4961516a.png";